import React, { PropsWithChildren } from 'react';
import { Modal } from 'react-bootstrap';

import { CloseIcon } from 'shared/icons/icons';

export interface IModalProps extends PropsWithChildren {
	show: boolean;
	handleClose: () => void | undefined;
	className?: string;
	modalTitle?: string;
	modalTitle2?: string | JSX.Element;
	modalTitle3?: string | JSX.Element;
	dataTestId?: string;
	footer?: JSX.Element | boolean;
	loading?: boolean;
	restrictCloseOnEscape?: boolean;
	closeOnOutSideClick?: boolean;
	dialogClassName?: string;
	hideBackDrop?: boolean;
}

const CustomModal: React.FC<IModalProps> = (props) => {
	return (
		<Modal
			show={props.show}
			onHide={() => (props.closeOnOutSideClick ? props.handleClose() : false)}
			onEscapeKeyDown={props.handleClose}
			className={`custom-modal ${props.className || ''} fadeIn `}
			keyboard={!props.restrictCloseOnEscape ?? true}
			dialogClassName={props.dialogClassName}
			backdrop={!props.hideBackDrop}
		>
			<Modal.Body>
				{props.modalTitle ? (
					<Modal.Header closeButton>
						<Modal.Title>
							{props.modalTitle2}
							{props.modalTitle3}
						</Modal.Title>
					</Modal.Header>
				) : (
					<div className='modal-close-btn' onClick={props.handleClose}>
						<CloseIcon />
					</div>
				)}
				{props.children}
			</Modal.Body>
			{!!props.footer && <Modal.Footer>{props.footer}</Modal.Footer>}
		</Modal>
	);
};

export default CustomModal;
